import styled from 'styled-components';

export const SearchWidgetWrap = styled.section`
  width: 50%;
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
  position: relative;
  z-index: 6;
  border-radius: 1.2rem;
  padding: 2.5rem;
  margin-right: 2rem;
  max-height: 360px;
  height: 100%;
`;
export const InputText = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    position: relative;
    label {
        font-size: 1.6rem;
        color: #898b91;
    }
    input[type=text] {
        border: 0;
        outline: 0;
        border-bottom: 1px solid #eff3f8;
        padding: 1rem 0;
        font-size: 1.8rem;
        font-weight: bold;
        font-family: ${props.theme.font.fontFamily};
        &::placeholder { 
            overflow: visible; 
            font-weight: bold;
            color: #898b91;
        }
        &.active {
            border-bottom: 1px solid #2276e3;
        }
    }
`,
);
export const CalendarBlock = styled.div`
  padding: 0 0 1rem;
  border-bottom: 1px solid #eff3f8;
  display: flex;
  flex-direction: column;
  label {
    font-size: 1.6rem;
    color: #898b91;
  }
`;
export const DateWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
    input {
        border: 0;
        outline: 0;
        padding: 1rem 0;
        font-size: 1.8rem;
        font-weight: bold;
        font-family: ${props.theme.font.fontFamily};
        &::placeholder { 
            overflow: visible; 
            font-weight: bold;
            color: #898b91;
        }
        
    }
`,
);
export const DateTabs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    border-radius: 8px;
    background-color: rgba(34, 118, 227, 0.1);
    padding: 1rem 1.5rem;
    font-size: 1.4rem;
    color: #2276e3;
    margin-left: 1rem;
    cursor: pointer;
    &.active {
      border-bottom: 2px solid #2276e3;
    }
  }
`;
export const InfoBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2rem 0 1rem;
  font-size: 1.4rem;
`;
export const goSafeTag = styled.p`
  background: #e9f6ea;
  border-radius: 0.4rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  margin-right: 0.5rem;
  span {
    font-weight: bold;
    color: black;
  }
`;
export const ButtonWrap = styled.div(
  props => `
    
    display: flex;
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
    button {
        border: 0;
        outline: 0;
        background-color: rgb(255, 109, 56);
        height: 6rem;
        width: 27rem;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        cursor: pointer;
        border-radius: 3rem;
        color: white;
        font-size: 2.2rem;
        font-family: Quicksand;
        font-weight: bold;
        box-shadow: rgba(0, 0, 0, 0.13) 0px 0.2rem 1.2rem 0px;
    }
`,
);
export const Tooltip = styled.div`
  position: relative;
  cursor: pointer;
  color: #2276e3;
  p {
    color: black;
  }
  &:hover {
    .arrow_box {
      display: block;
    }
  }

  .arrow_box {
    position: relative;
    background: #d1e5ff;
    border: 2px solid #9bc2f6;
    border-radius: 0.8rem;
    padding: 1rem;
    width: 30rem;
    position: absolute;
    left: -119px;
    margin-top: 10px;
    z-index: 2;
    display: none;
    .tag {
      display: inline-flex;
      background: white;
      padding: 0.2rem 1rem;
      flex-direction: row;
      align-items: center;
      font-size: 1.2rem;
      color: #2276e3;
      border-radius: 20px;
      margin-bottom: 0.5rem;
      span {
        padding-left: 0.5rem;
      }
    }
  }
  .arrow_box:after,
  .arrow_box:before {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(209, 229, 255, 0);
    border-bottom-color: #d1e5ff;
    border-width: 10px;
    margin-left: -10px;
  }
  .arrow_box:before {
    border-color: rgba(155, 194, 246, 0);
    border-bottom-color: #9bc2f6;
    border-width: 13px;
    margin-left: -13px;
  }
`;
export const SwapIconWrap = styled.span`
  position: absolute;
  right: 0;
  transform: rotate(-90deg);
  top: 67px;
  right: 25px;
  cursor:pointer;
`;
export const AutoSuggestList = styled.ul`
  z-index: 99;
  position: absolute;
  top: 6rem;
  left: 0px;
  list-style-type: none;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 14px 0px;
  transform: translateY(4px);
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  background: rgb(255, 255, 255);
  border-radius: 4px;
`;
export const ListItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  border-top: 1px solid rgb(220, 221, 222);
  padding: 1rem 1.6rem;
  background: rgb(255, 255, 255);
  cursor: pointer;
`;
export const CalendarBlockOuterWrapper = styled.div(
  props => `
    width: 37.5rem;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    margin-top: ${props.isSearchWidget ? '6.5rem' : '11rem'};
    // left: 0;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: 1.2rem;
  `,
);
